import React, { Component } from 'react';
import './Steps.scss';
import device from '../../../Assets/images/Activation/device.svg';
import deviceImei from '../../../Assets/images/Activation/deviceImei.svg';
import current from '../../../Assets/images/Activation/current.svg';
import account from '../../../Assets/images/Activation/account.svg';
import sim from '../../../Assets/images/Activation/sim.svg';
import pin from '../../../Assets/images/Activation/pin.svg';
import zip from '../../../Assets/images/Activation/zip.svg';
import call from '../../../Assets/images/Activation/Shape.svg';
import Button from '../../../components/Button/Button';
import BackButton from '../../../Assets/images/commonImages/backButton.svg'
import { activationPage } from '../../../global/texts/postActivation/activation';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Action from '../../../store/Checkout/actions';
import * as ActivationAction from '../../../store/Activation/actions';
import * as HomeAction from '../../../store/HomePage/actions';
import { updateToHubspot } from '../../../global/commonFunctions/hubspot';
import { globalVal } from '../../../global/globalvalues';
import { store } from 'react-notifications-component';
import firebase from '../../../utils/firebase';
import Steps from '../../../components/Steps/StaticSteps';
import successIcon from '../../../Assets/images/Activation/success.svg';
import inProgressIcon from '../../../Assets/images/Activation/inProgress.svg';
import failedIcon from '../../../Assets/images/Activation/failed.svg';
import GenericError from '../../../components/GenericError/GenericError';
import { getUserName } from '../../../global/commonFunctions/getUserName';

type initialProps = {
    history: any;
    changeCurrentPage: any;
    ActivationActions: any;
    ActivationState: any;
    homeAction: any;
    homeState: any;
    CheckoutActions: any;
    CheckoutState: any;
};
type initialState = {
    user: any;
    simId: string;
    activationFailModal: boolean;
    ImeiFailModal: boolean;
    modal5G: boolean;
    activationTrueIsMnp: boolean;
    contactInfoModal: boolean;
    activationLoading: boolean;
    eSim: boolean;
    ios: boolean;
    android: boolean;
    showSetupProfileModal: boolean;
    confirmed: boolean;
    stepCount: number;
    sliceStartCount: number;
    sliceEndCount: number;
    stepImgCount: number;
    actFailed: boolean;
    actInProgress: boolean;
    actSuccess: boolean;
    currentUser: any;
    isResendKitSuccess: boolean;
    isResendKitClicked: boolean;
    portInProgress: boolean;
    isPortFailed: boolean;
    isPortingCase: boolean;
    statusPassword: any;
    fromPorting: boolean;
    genericErr: boolean;
    isActivationGenericErr: boolean;
};
export class Step4 extends Component<initialProps, initialState> {
    state: initialState = {
        user: null,
        simId: '',
        activationFailModal: false,
        ImeiFailModal: false,
        modal5G: false,
        activationTrueIsMnp: false,
        contactInfoModal: false,
        activationLoading: false,
        eSim: false,
        ios: true,
        android: false,
        showSetupProfileModal: false,
        confirmed: false,
        stepCount: 1,
        sliceStartCount: 0,
        sliceEndCount: 4,
        stepImgCount: 0,
        actFailed: false,
        actInProgress: false,
        actSuccess: false,
        currentUser: '',
        isResendKitSuccess: false,
        isResendKitClicked: false,
        portInProgress: false,
        isPortFailed: false,
        isPortingCase: false,
        statusPassword: '',
        fromPorting: false,
        genericErr: false,
        isActivationGenericErr: false,
    };

    componentDidMount() {
        let userData: any = localStorage.getItem('customerDetail');
        let sim: any = localStorage.getItem('simId');
        let simId: string = sim ? sim : '';
        userData = JSON.parse(userData);
        let fromPorting: any = localStorage.getItem('fromPorting');
        if(fromPorting) {
            fromPorting = JSON.parse(fromPorting);
            this.setState({ fromPorting })
        }

        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        if (secondaryCustomer) {
            secondaryCustomer = JSON.parse(secondaryCustomer);
            this.setState({
                eSim: secondaryCustomer.esim,
                currentUser: secondaryCustomer,
            });
        } else {
            if (userData) {
                this.setState({
                    eSim: userData.esim,
                    currentUser: userData,
                });
            }
        }
        this.setState({ user: secondaryCustomer ? secondaryCustomer : userData, simId: simId });
        this.removeAllTickers();
    }

    componentWillUnmount() {
        this.removeAllTickers();
    }

    removeAllTickers() {
        store.removeNotification('activationNotify5G');
    }

    componentDidUpdate(prevProps: initialProps) {
        const prev = prevProps && prevProps.ActivationState;
        const cur = this.props && this.props.ActivationState;
        let prevOne = prevProps && prevProps.CheckoutState;
        let curOne = this.props && this.props.CheckoutState;

        const { user, currentUser } = this.state;

        if (prev.activation !== cur.activation && cur.activation && cur.activation.status === 'SUCCESS') {
            // let currentdetails: any = localStorage.getItem('customerDetail');
            // currentdetails = JSON.parse(currentdetails);
            if(this.state.fromPorting !== true) {
                this.setState({ actInProgress: true })
                this.props.ActivationActions.activationStatus({ customerId: currentUser && currentUser.id });
            } else {
                // this.setState({ isPortingCase: true, portInProgress: true })
                this.props.history.push({
                    pathname: '/status',
                    state: {
                        portInProgress: true,
                        user: currentUser,
                    }
                })
            }
            this.setState({ activationLoading: false})
        }

        if (prev.resendStatus !== cur.resendStatus && cur.resendStatus && cur.resendStatus.status === 'SUCCESS') {
            this.setState({ isResendKitClicked: false })
        }

        if (prev.errorResendStatus !== cur.errorResendStatus && cur.errorResendStatus && cur.errorResendStatus.status === 'FAILURE') {
            this.setState({ isResendKitClicked: false })
        }

        if (
            prev.errorActivation !== cur.errorActivation &&
            cur.errorActivation &&
            cur.errorActivation.status === 'FAILURE'
        ) {
            if(this.state.fromPorting === true) {
                // this.setState({ isPortingCase: true, genericErr: true });
                this.props.history.push({
                    pathname: '/status',
                    state: {
                        genericErr: true,
                        user: currentUser,
                    }
                })
            } else if(cur.errorActivation.resCode === 40624) {
                this.props.history.push('/activation-error');
            } else if (cur.errorActivation.resCode === 40622) {
                this.setState({ isActivationGenericErr: true });
            } else {
                this.setState({ 
                    actFailed: true, 
                    actInProgress: false,
                })
            }
            this.setState({ activationLoading: false })
            let data = cur.errorActivation;
            if (data && data.resCode === 40231) {
                // this.setState({ ImeiFailModal: true });
            } else if (data && data.resCode === 40245) {
                // this.setState({ activationFailModal: true });
                let payload: any = {
                    imei_checked_in_downtime: true,
                    imei_page_imei_entered: user && user.imei,
                    downtime_api_call: true,
                    downtime_error_message: data && data.message,
                    email: user && user.emailId,
                };
                updateToHubspot(payload, this.state.user && user.emailId);
                this.props.homeAction.getInTouch(payload);
            } else if (data && data.resCode === 40267) {
                // this.setState({ modal5G: true }); // 5g
                let payload: any = { is_5G_device: true, email: user && user.emailId };
                updateToHubspot(payload, user && user.emailId);
                this.props.homeAction.getInTouch({
                    data: {
                        emailId: user && user.emailId,
                        hubspotMap: payload,
                    },
                });
            } else {
                // this.setState({ activationFailModal: true });
            }
        }
        if (
            prev.errorActivationStatus !== cur.errorActivationStatus &&
            cur.errorActivationStatus &&
            cur.errorActivationStatus.status === 'FAILURE'
        ) {
            // let customerDetail: any = localStorage.getItem('customerDetail');
            // customerDetail = JSON.parse(customerDetail);
            setTimeout(() => {
                this.props.ActivationActions.activationStatus({
                    customerId: currentUser && currentUser.id,
                });
            }, 5000);
        }

        if (
            prev.activationStatus !== cur.activationStatus &&
            cur.activationStatus &&
            cur.activationStatus.status === 'SUCCESS' &&
            cur.activationStatus.data
        ) {
            let status = cur.activationStatus.data;
            let customerDetail: any = localStorage.getItem('customerDetail');
            customerDetail = JSON.parse(customerDetail);
            if (status && (status.status === 1 || status.status === 9)) {
                setTimeout(() => {
                    this.props.ActivationActions.activationStatus({
                        customerId: currentUser && currentUser.id,
                    });
                }, 5000);
            } else if (status && (status.status === 10)) {
                this.props.history.push({
                    pathname: '/status',
                    state: {
                        genericErr: true,
                        user: currentUser,
                    }
                })
            } else {
                this.props.CheckoutActions.GetCustomer({
                    username: encodeURIComponent(customerDetail && customerDetail.emailId),
                });
                if (status && (status.status === 2 && currentUser?.esim && !currentUser?.eSimSetup)) {
                    this.setState({ actSuccess: true, actInProgress: false })
                }
                if (status && status.password) {
                    this.setState({
                        statusPassword: status.password,
                    });
                }
                if(status?.status === 10) {
                    this.setState({
                        isPortFailed: true
                    })
                }
            }
        }
        if (
            prevOne.getCustomer !== curOne.getCustomer &&
            curOne.getCustomer &&
            curOne.getCustomer.status === 'SUCCESS' &&
            curOne.getCustomer.data
        ) {
            // let customerDetail: any = localStorage.getItem('customerDetail');
            // customerDetail = JSON.parse(customerDetail);
            if (curOne.getCustomer.data.status !== 2) {
                this.props.ActivationActions.activationStatus({
                    customerId: currentUser && currentUser.id,
                });
            } else {
                this.setState({ actSuccess: true, actInProgress: false })
            }
        }

        if (
            prevOne.errorGetCustomer !== curOne.errorGetCustomer &&
            curOne.errorGetCustomer &&
            curOne.errorGetCustomer.status === 'FAILURE' &&
            curOne.errorGetCustomer.data
        ) {
            // this.props.history.push('/post-activation-home');
        }
    }

    activateHandler = () => {
        let customerId: any = this.props?.history?.location?.secondaryCustomerID;
        const { user, simId } = this.state;
        let payload: any = {
            customerId: customerId ? customerId : user.id,
            reachPlanId: user && user.reachPlanId,
            iccId: simId,
            imei: user && user.imei,
            make: user && user.make,
            model: user && user.model,
            skipHold: true,
        };

        if (user && user.isMNP) {
            payload.isPort = true;
            payload.numberToPort = user && user.mnpInfo && user.mnpInfo.oldNumber.replace(/(\D)/g, '');
            payload.oldCarrier = user && user.mnpInfo && user.mnpInfo.operator;
            payload.oldCarrierAccountNumber = user && user.mnpInfo && user.mnpInfo.acctNum;
            payload.password = user && user.mnpInfo && user.mnpInfo.oldPassword;
            payload.oldZip = user && user.mnpInfo && user.mnpInfo.oldZip;
            // payload.portUpdate = false;
        }
        this.props.ActivationActions.activation(payload);
        this.setState({
            activationLoading: true,
        });
    };
    backHandler = () => {
        if (this.state.isResendKitSuccess) {
            this.setState({ isResendKitSuccess: false })
            return
        }
        this.state.user && this.state.user.isMNP === true
            ? this.props.changeCurrentPage('Step2')
            : this.props.changeCurrentPage('Step3');
    };
    nextHandler = () => {
        if (this.state.user && this.state.user.isPrimary) {
            this.props.CheckoutActions.GetCustomer({
                username: encodeURIComponent(this.state.user && this.state.user.emailId),
            });
        } else {
            // this.props.history.push('/account');
            this.props.history.push('/post-activation-home');
        }
    };
    tryAgainHandler = () => {
        this.setState({ ImeiFailModal: false, modal5G: false });
        this.props.changeCurrentPage('Step1');
    };
    notifyMeHandler = () => {
        let payload: any = {
            is_test: globalVal.hubspot_is_test,
            is_qa: globalVal.hubspot_is_qa,
            email: this.state.user && this.state.user.emailId,
            website_imei_incompatibility_reason: '5GDevice',
        };
        updateToHubspot(payload, this.state.user && this.state.user.emailId);
        this.props.homeAction.getInTouch({
            data: {
                emailId: this.state.user && this.state.user.emailId,
                hubspotMap: payload,
            },
        });
        this.setState({ modal5G: false });
        store.addNotification({
            message: activationPage && activationPage.step4 && activationPage.step4.notifymsg,
            type: 'info',
            insert: 'top',
            container: 'top-full',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
                duration: 2000,
                showIcon: true,
            },
            id: 'activationNotify5G',
        });
    };

    handleLogout = () => {
        const thiss = this;
        firebase
            .auth()
            .signOut()
            .then(() => {
                localStorage.removeItem('currentuser');
                localStorage.removeItem('accessToken');
                localStorage.clear();
                thiss.props.history.push('/');
            })
            .catch(err => {
                console.log(err);
            });
        localStorage.clear();
    };
    continueHandler = () => {
        const updatedValue = {
            eSimSetup: true,
            activationJourneyStatus: 'COMPLETED',
        }
        this.props.CheckoutActions.UpdateCustomerSource({
            customerId: this.state.user?.id,
            data: updatedValue
        })
        this.props.history.push('/post-activation-home');
    };
    resendKit = () => {
        this.setState({ isResendKitClicked: true })
        this.props.ActivationActions.resendESimKit({ customerId: this.state.currentUser && this.state.currentUser.id });
    }
    handleGenericErrorCTA = () => {
        this.setState({ isActivationGenericErr: false });
    };

    render() {
        const {
            user,
            simId,
            activationTrueIsMnp,
            ios,
            android,
            currentUser,
            actFailed,
            actInProgress,
            actSuccess,
            isActivationGenericErr,
        } = this.state;

        let { step4 } = activationPage;
        return (
            <div>
                {!(actFailed || actInProgress || actSuccess || isActivationGenericErr) && (
                    <div className="backButtonActivation" >
                        <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                        <div className="titleMainActivation">
                            {activationTrueIsMnp
                                ? step4?.activationIsMnp?.title
                                // : this.state.eSim && !isResendKitSuccess ? 'Set up profile using the QR code'
                                //     : this.state.eSim && isResendKitSuccess ? 'Resend eSIM Kit'
                                : `${getUserName()}'s Line is Ready For Activation`}
                        </div>
                    </div>
                )}
                {activationTrueIsMnp ? ( //className="ActvationIsMnpScreen"
                    <div className="step4Activation">
                        <div className="subTitleSuccessIsmnp">
                            {step4 &&
                                step4.activationIsMnp &&
                                step4.activationIsMnp.subTitle.replace('{0}', user.firstName)}
                        </div>
                        <div className="activationBox">
                            <div className="stepsonSuccessActivationMnp">
                                {step4 &&
                                    step4.activationIsMnp &&
                                    step4.activationIsMnp.content &&
                                    step4.activationIsMnp.content.length > 0 &&
                                    step4.activationIsMnp.content.map((el: any, index: number) => {
                                        return (
                                            <div key={index} className="stepsonSuccessActivation">
                                                <div className="imgDiv">
                                                    <img src={el && el.icon} alt="" />
                                                </div>
                                                <div className="titleDiv">
                                                    {index + 1}. {el && el.title}
                                                </div>
                                                <div className="contentDiv">{el && el.content}</div>
                                            </div>
                                        );
                                    })}
                            </div>
                            <div className="activate-button">
                                <Button primary={true} onClick={this.nextHandler}>
                                    Next
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : this.state.eSim
                    ? (
                        <div style={{ marginBottom: "400px" }}>
                            <div className="stepsBox">
                                <Steps ios={ios} android={android} />
                            </div>
                        </div>
                    ) : isActivationGenericErr ? (
                        <GenericError handleGenericErrorCTA={this.handleGenericErrorCTA} />
                    ) : actFailed ? (
                        <div className="activationStatus">
                            <img src={failedIcon} />
                            <div className="activationStatusTitle">Activation Failed</div>
                            <div className="activationStatusSubtitle">Sorry, we couldn't complete line activation for {getUserName() + " " + currentUser?.lastName?.toUpperCase()} due to an unexpected error. Please get in touch with our Care Team to resolve this and activate your line.</div>
                            <div className="call">
                                <img src={call} alt="phone" />
                                <span className='contactNumber'>CALL 1.800.427.8686</span>
                            </div>
                            <div className="backToHome">
                                <div onClick={() => this.props.history.push('/post-activation-home')}>Home</div>
                            </div>
                        </div>
                    ) : actInProgress ? (
                        <div className="activationStatus">
                            <img src={inProgressIcon} />
                            <div className="activationStatusTitle">Activation in Progress</div>
                            <div className="activationStatusSubtitle">
                                Activation for {getUserName()}'s line has begun. Please click the green 'Continue to Home' button to monitor the activation progress. We will let you know once the activation process is complete.
                            </div>
                            <div className="backToHomeBtn">
                                <Button
                                    primary={true}
                                    onClick={() => this.props.history.push('/post-activation-home')}
                                >
                                    Continue To Home
                                </Button>
                            </div>
                        </div>
                    ) : actSuccess ? (
                        <div className="activationStatus">
                            <img src={successIcon} />
                            <div className="activationStatusTitle">Activation Successful</div>
                            <div className="activationStatusSubtitle">Congratulations! {getUserName()}'s line has been successfully activated.<br />You can now enjoy all the features and benefits of our {globalVal.long_name} services.</div>
                            <Button primary={true} onClick={() => this.props.history.push('/post-activation-home')}>
                                CONTINUE
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <div className="ProgressBarActivation">
                                <div className="stepsCount">Step 4 of 4</div>
                                <ProgressBar variant="success" now={100} className="progressBar" />
                            </div>
                            <div className="step4Activation">
                                <div className="activationBox">
                                    <div className="activationFinalHeading">Last step! Confirm your details</div>
                                    <div className="activationFinalSubHeading">
                                        Please give this information one more look, then tap the activate button to get the ball rolling.
                                    </div>
                                    <div className="activationDetailsBlk">
                                        <div className="actDeviceName">
                                            <div className="actDevice">
                                                <img src={device} alt="" />
                                                <div className="media-body">
                                                    <div className="actFinalSubHeading">Device</div>
                                                    <div className="actDeviceNameText">{user && user.model}</div>
                                                </div>
                                            </div>
                                            <div className="actDevice">
                                                <img src={deviceImei} alt="" />
                                                <div className="media-body">
                                                    <div className="actFinalSubHeading">Device ID (IMEI)</div>
                                                    <div className="actDeviceNameText">{user && user.imei}</div>
                                                </div>
                                            </div>
                                            {user && user.isMNP && (
                                                <div className="actDevice">
                                                    <img src={current} alt="" />
                                                    <div className="media-body">
                                                        <div className="actFinalSubHeading">Current no.</div>
                                                        <div className="actDeviceNameText">
                                                            {user && user.mnpInfo && user.mnpInfo.oldNumber}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="actDevice">
                                                <img src={sim} alt="" />
                                                <div className="media-body">
                                                    <div className="actFinalSubHeading">SIM no.</div>
                                                    <div className="actDeviceNameText">{simId}</div>
                                                </div>
                                            </div>
                                            {user && user.isMNP && (
                                                <div className="actDevice">
                                                    <img src={account} alt="" />
                                                    <div className="media-body">
                                                        <div className="actFinalSubHeading">Account no.</div>
                                                        <div className="actDeviceNameText">
                                                            {user && user.mnpInfo && user.mnpInfo.acctNum}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {user && user.isMNP && (
                                                <div className="actDevice">
                                                    <img src={pin} alt="" />
                                                    <div className="media-body">
                                                        <div className="actFinalSubHeading">PIN</div>
                                                        <div className="actDeviceNameText">
                                                            {user && user.mnpInfo && user.mnpInfo.oldPassword}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {user && user.isMNP && (
                                                <div className="actDevice">
                                                    <img src={zip} alt="" />
                                                    <div className="media-body">
                                                        <div className="actFinalSubHeading">Zip Code</div>
                                                        <div className="actDeviceNameText">
                                                            {user && user.mnpInfo && user.mnpInfo.oldZip}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="activate-button">
                                        <Button
                                            primary={true}
                                            onClick={!this.state.activationLoading ? this.activateHandler : ()=>{}}
                                            disabled={this.state.activationLoading}
                                        >
                                            {this.state.activationLoading ? (
                                                <div
                                                    className="spinner-border"
                                                    role="status"
                                                    style={{
                                                        alignSelf: 'center',
                                                    }}
                                                />
                                            ) : (
                                                'Activate'
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        ActivationActions: bindActionCreators(ActivationAction, dispatch),
        homeAction: bindActionCreators(HomeAction, dispatch),
        CheckoutActions: bindActionCreators(Action, dispatch),
    };
}

const mapStateToProps = (state: any) => ({
    ActivationState: state.activation,
    homeState: state.home,
    CheckoutState: state.checkout,
});

export default connect(mapStateToProps, mapDispatchToProps)(Step4);
